<template>
  <div class="chatflow-editor" autocomplete="off">
    <!-- Chrome şifre yöneticisini tetiklemesin -->
    <form class="cf-autofill-shield" aria-hidden="true" tabindex="-1" @submit.prevent>
      <input type="text" name="chatflow-shield" autocomplete="off" tabindex="-1" />
    </form>
    <div class="cf-editor-topbar">
      <v-btn icon small to="/chatflows" title="Chatflows listesi">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <span class="cf-editor-topbar__title">{{ flowName || "Chatflow" }}</span>
      <v-spacer />
      <v-chip v-if="!editorUrl" small color="warning" text-color="white">
        config.json: chatflowURL (Kong /chatflow)
      </v-chip>
    </div>
    <iframe
      v-if="editorUrl"
      ref="editorFrame"
      class="chatflow-editor-frame"
      :src="editorUrl"
      title="Chatflow editor"
      autocomplete="off"
      @load="onFrameLoad"
    />

    <v-snackbar
      v-model="snack"
      :color="snackColor"
      bottom
      :timeout="3500"
      class="cf-editor-snack"
    >
      {{ snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn text dark v-bind="attrs" @click="snack = false">Kapat</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Auth from "../../auth";
import chatflowConfig from "../config";
import ChatflowApi from "../api";

export default {
  data: () => ({
    flowName: "",
    editorUrl: "",
    snack: false,
    snackText: "",
    snackColor: "success",
  }),
  async created() {
    const id = this.$route.params.id;
    if (!id) {
      this.$router.replace("/chatflows");
      return;
    }
    try {
      const flow = await ChatflowApi.getFlow(id);
      this.flowName = flow.name;
    } catch (e) {
      console.error(e);
    }
    this.editorUrl = chatflowConfig.adminEmbedUrl(id);
  },
  mounted() {
    window.addEventListener("message", this.onMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.onMessage);
  },
  methods: {
    onFrameLoad() {
      this.postToken();
    },
    onMessage(event) {
      const data = event.data;
      if (!data || typeof data !== "object") return;
      if (data.type === "chatflow:ready") {
        this.postToken();
        return;
      }
      if (data.type === "chatflow:toast" && data.message) {
        this.notify(data.message, data.variant || "success");
      }
    },
    notify(text, color = "success") {
      const now = Date.now();
      if (this._lastSnackText === text && now - (this._lastSnackAt || 0) < 900) return;
      this._lastSnackText = text;
      this._lastSnackAt = now;
      const map = { success: "success", error: "error", warning: "warning", info: "info" };
      this.snackText = text;
      this.snackColor = map[color] || color || "success";
      this.snack = true;
    },
    postToken() {
      const frame = this.$refs.editorFrame;
      if (!frame || !frame.contentWindow) return;
      const token = Auth.getToken();
      if (!token) return;
      let target = "*";
      try {
        target = new URL(this.editorUrl).origin;
      } catch (_) {
        /* ignore */
      }
      frame.contentWindow.postMessage({ type: "chatflow:setToken", token }, target);
    },
  },
};
</script>

<style scoped>
/* v-main mx-4 my-4 + app-bar 65px — iframe tam kalan alanı doldursun */
.chatflow-editor {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 65px - 32px);
  min-height: 480px;
  margin: -16px;
  width: calc(100% + 32px);
  background: #f0f2f5;
  overflow: hidden;
}

.cf-editor-topbar {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 4px 8px 8px;
  background: #f0f2f5;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.cf-editor-topbar__title {
  font-size: 1rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}

.chatflow-editor-frame {
  flex: 1 1 auto;
  width: 100%;
  border: none;
  min-height: 0;
  display: block;
  background: #f0f2f5;
}

.cf-autofill-shield {
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}
</style>
